<template>
  <div class="cz-regulatory-wrapper">
    <cz-regulatory-header :displayed-time="displayedTime" @removeClosingEvents="removeClosingEvents" />
    <slot></slot>
    <cz-regulatory-overlay v-if="isCooldownActive && !isFeatureStarted" :displayed-time="displayedTime" />
    <cz-regulatory-footer v-bind="{ balance, isInitialBetPlayed, currency, userDevice }" />
    <!-- <div style="position: absolute; top:0; right: 20%; display: flex; justifyContent: center;">
      <button @click="setGameTestState('gameplay')">Gameplay</button>
      <button @click="setGameTestState('rest')">Rest</button>
      <button @click="setGameTestState('cooldown')">Cooldown</button>
    </div> -->
  </div>
</template>

<script>
import Regulatory from './regulatory';
import CzRegulatoryHeader from './regulatoryHeader';
import CzRegulatoryOverlay from './regulatoryOverlay';
import CzRegulatoryFooter from './regulatoryFooter';

export default {
  name: 'CZRegulatory',
  mixins: [Regulatory],
  components: { CzRegulatoryHeader, CzRegulatoryOverlay, CzRegulatoryFooter },
  props: { userDevice: { type: String, default: 'd' }}
}
</script>

<style lang="scss" scoped>
.cz-regulatory-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
</style>
